// Carry Roll CalculatorScreen — Screen 1 (primary). 2-column grid: inputs | results.

import { TopControlBar } from '../components/calculator/TopControlBar';
import { LaunchInputs } from '../components/calculator/LaunchInputs';
import { ConditionsInputs } from '../components/calculator/ConditionsInputs';
import { LandingOverrideInput } from '../components/calculator/LandingOverrideInput';
import { ValidationErrors } from '../components/calculator/ValidationErrors';
import { TrajectoryView } from '../components/calculator/TrajectoryView';
import { ResultsBlock } from '../components/calculator/ResultsBlock';
import { ExplanationBox } from '../components/calculator/ExplanationBox';
import { ConfidenceBadge } from '../components/calculator/ConfidenceBadge';
import { RollSegmentView } from '../components/calculator/RollSegmentView';
import { OfflineView } from '../components/calculator/OfflineView';

export default function CalculatorScreen() {
  return (
    <div
      className="grid gap-4 grid-cols-1 md:grid-cols-2"
      data-testid="calculator-screen"
    >
      {/* Left column — inputs */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--gap-panel)' }}>
        <TopControlBar />
        <LaunchInputs />
        <ConditionsInputs />
        <LandingOverrideInput />
        <ValidationErrors />
      </div>

      {/* Right column — results (always visible) */}
      <div className="stagger" style={{ display: 'flex', flexDirection: 'column', gap: 'var(--gap-panel)' }}>
        <div className="flex items-center justify-between">
          <h2 className="section-title">
            Result
          </h2>
          <ConfidenceBadge />
        </div>
        <TrajectoryView />
        <div className="flex gap-3 flex-wrap">
          <RollSegmentView />
          <OfflineView />
        </div>
        <ResultsBlock />
        <ExplanationBox />
      </div>
    </div>
  );
}
